import React from 'react';
import { Image, Typography } from 'fronton-react';
import { LoyaltyRegistartionBannerWrapper } from './styles';
import { useTranslation } from 'react-i18next';

const LOYALTY_CARDS_ICON_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/v1770891197/fudzi/navigation-microfronts/header/loyalty_cards.png/loyalty_cards.png';

export const LoyaltyRegistrationBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LoyaltyRegistartionBannerWrapper
      as="a"
      id="loyalty-registration-banner"
      data-qa="loyalty-registration-banner"
    >
      <Typography size="subtitle" variant="s">
        {t('header.main.user-menu.loyalty-registration-banner.get-points')}
      </Typography>
      <Image
        width="120px"
        height="86px"
        src={LOYALTY_CARDS_ICON_PATH}
        alt={t('header.main.user-menu.loyalty-registration-banner.loyalty-cards-icon-alt')}
      />
    </LoyaltyRegistartionBannerWrapper>
  );
};
